import * as React from "react";
import { ComponentClass } from "react";
import { BranchActions, IBranchStore } from "../store/branch";
import { IStore } from "../store";
import { connect } from "react-redux";
import { JSONSchema6 } from "json-schema";
import { ISubmitEvent } from "react-jsonschema-form";
import StandaloneSearchBox from "react-google-maps/lib/components/places/StandaloneSearchBox";

// api
import { getApi } from "../api/ApiProvider";
import { Branch } from "../api/model";

// material
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityOnIcon from "@material-ui/icons/Visibility";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import EditIcon from "@material-ui/icons/ModeEdit";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import { SortDirection } from "@material-ui/core/TableCell";
import Grid from "@material-ui/core/Grid";
import { Theme, WithStyles } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import red from "@material-ui/core/colors/red";
import green from "@material-ui/core/colors/green";
import blue from "@material-ui/core/colors/blue";

// utils
import { bindActions, mockTheme } from "../utils/utils";

// components
import EnhancedSchemaForm from "../components/schemaForm";
import AsyncTable, { ColumnDefinition } from "../components/AsyncTable";
import LocationMap from "../components/LocationMap";

const styles = (theme: Theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: `calc(50% - ${theme.spacing.unit * 3}px)`,
  },
  menu: {
    width: 200,
  },

  routeSelector: {
    width: "100%",
    height: "100%",
  },
  buttons: {
    marginLeft: "auto",
  },
  abm: {
    padding: theme.spacing.unit * 3,
    margin: theme.spacing.unit,
  },
  disableIcon: {
    color: red[900],
  },
  enableIcon: {
    color: green[900],
  },
  editIcon: {
    color: blue[500],
  },
  textMap: {
    textAlign: "center",
  },
});

/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface BranchProps extends WithStyles<keyof typeof classesType> {
  actions: BranchActions;
  data: IBranchStore;
  user: any;
}

interface BranchState {
  schemaBranch: any;
  duplicateBranch: boolean;
  branchsCompany: any;
  street: any;
  center: { lat: any; lng: any };
  idLocation?: number;
  abm: {
    id?: number;
    name: string;
    street1: string;
    street2: string;
    observation: string;
    number: string;
    open: boolean;
    state: string;
    activeForm: boolean;
  };
  table: {
    data: any;
    sortBy: string;
    sortDirection: SortDirection;
    columnData: ColumnDefinition[];
  };
}

const schema: JSONSchema6 = {
  title: "Sucursal",
  type: "object",
  required: ["name", "street1"],
  properties: {
    name: { type: "string", title: "Nombre" },
    street1: { type: "string", title: "Calle principal" },
    street2: { type: "string", title: "Calle 2" },
    observation: { type: "string", title: "Observación" },
    number: { type: "string", title: "Teléfono" },
  },
};

class Branchs extends React.Component<BranchProps, BranchState> {
  refStreet: StandaloneSearchBox;

  companyId = this.props.user.companyId;

  constructor(props: BranchProps) {
    super(props);

    this.state = {
      schemaBranch: schema,
      duplicateBranch: false,
      branchsCompany: [],
      abm: {
        id: 0,
        name: "",
        street1: "",
        street2: "",
        observation: "",
        number: "",
        open: false,
        state: "",
        activeForm: false,
      },
      table: {
        data: [],
        sortBy: "name",
        sortDirection: "desc",
        columnData: [
          {
            path: "name",
            numeric: false,
            disablePadding: true,
            label: "Nombre",
          },
          {
            path: "location.street1",
            numeric: false,
            disablePadding: false,
            label: "Dirección",
          },
          {
            path: "location.number",
            numeric: false,
            disablePadding: false,
            label: "Teléfono",
          },
          {
            path: "state",
            numeric: false,
            disablePadding: false,
            label: "Estado",
          },
          {
            path: "",
            numeric: false,
            label: "Acciones",
            draw: (cd: ColumnDefinition, data: Branch) => {
              return (
                <div>
                  <IconButton
                    className={
                      data.state === "ACTIVE"
                        ? this.props.classes.enableIcon
                        : this.props.classes.disableIcon
                    }
                    onClick={
                      data.state === "ACTIVE"
                        ? this.handleDisable(data)
                        : this.handleActivate(data)
                    }
                  >
                    {data.state === "ACTIVE" ? (
                      <Tooltip title="Activo">
                        <VisibilityOnIcon />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Inactivo">
                        <VisibilityOffIcon />
                      </Tooltip>
                    )}
                  </IconButton>
                  <IconButton
                    className={this.props.classes.editIcon}
                    aria-label="Editar"
                    onClick={this.edit(data)}
                  >
                    <Tooltip title="Editar">
                      <EditIcon />
                    </Tooltip>
                  </IconButton>
                </div>
              );
            },
          },
        ],
      },
      street: "",
      center: { lat: -25.301878, lng: -57.5844456 },
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.showDialog = this.showDialog.bind(this);
    this.hideDialog = this.hideDialog.bind(this);
    this.changeLocation = this.changeLocation.bind(this);
    this.changeStreet = this.changeStreet.bind(this);
    this.onAddressMounted = this.onAddressMounted.bind(this);
  }

  onAddressMounted(ref: StandaloneSearchBox) {
    this.refStreet = ref;
  }

  validBranch(dataBranch: any) {
    const branchs = this.state.branchsCompany;
    const id = dataBranch.id;
    const name = dataBranch.name;
    const nameEval =
      id && name === this.state.abm.name ? "Null" : dataBranch.name;

    const filterBranchs = branchs.filter((b: any) => nameEval === b.name);

    console.log("filter branch", branchs);

    if (filterBranchs.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  getBranchCompany() {
    getApi()
      .branch()
      .listAllBranchesCompany(this.companyId)
      .then((data) => {
        this.setState({ branchsCompany: data });
      });
  }

  handleSubmit(e: ISubmitEvent<any>) {
    const valid = this.validBranch(e.formData);

    e.formData.lat = this.state.center.lat;
    e.formData.lng = this.state.center.lng;
    e.formData.companyId = this.companyId;
    e.formData.idLocation = this.state.idLocation || 0;

    if (e.formData.id && valid) {
      this.props.actions.save(e.formData);
      this.hideDialog();
      this.props.actions.fetch();
    } else {
      if (valid) {
        this.props.actions.save(e.formData);
        this.hideDialog();
        this.props.actions.fetch();
      } else {
        this.setState({ duplicateBranch: true });
        setTimeout(() => {
          this.setState({ duplicateBranch: false });
        }, 3000);
      }
    }
  }

  sort(name: string) {
    return () => {
      this.setState({
        ...this.state,
        table: {
          ...this.state.table,
          sortBy: name,
          sortDirection: "desc",
        },
      });
    };
  }

  edit(data: Branch) {
    return (event: React.MouseEvent<HTMLElement>) => {
      this.getBranchCompany();
      console.log("Data de sucursal: ", data);

      const { location } = data;
      this.setState({
        abm: {
          id: data.id,
          name: data.name,
          street1: location.street1,
          street2: location.street2 || "",
          observation: location.observation || "",
          number: location.number || "",
          open: true,
          state: data.state,
          activeForm: true,
        },
        duplicateBranch: false,
        idLocation: location.id,
        center: {
          lat: location.lat ? location.lat : this.state.center.lat,
          lng: location.lng ? location.lng : this.state.center.lng,
        },
        schemaBranch: schema,
      });
    };
  }

  handleDisable(data: any) {
    return (event: React.MouseEvent<HTMLElement>) => {
      this.props.actions.disable(data, this.companyId);
    };
  }

  handleActivate(data: any) {
    return (event: React.MouseEvent<HTMLElement>) => {
      this.props.actions.activate(data, this.companyId);
    };
  }

  hideDialog() {
    this.setState({
      abm: {
        ...this.state.abm,
        open: false,
      },
      duplicateBranch: false,
    });
  }

  showDialog() {
    this.setState({
      abm: {
        name: "",
        street1: "",
        street2: "",
        observation: "",
        number: "",
        open: true,
        state: "",
        activeForm: false,
      },
      duplicateBranch: false,
    });
  }

  changeLocation(location: any) {
    console.log("Location sucursal --->", location);

    this.setState({
      abm: {
        ...this.state.abm,
      },
      center: location,
    });
  }

  changeStreet(e: any) {
    console.log("street search: ", e);

    this.setState({
      abm: {
        ...this.state.abm,
      },
      street: e,
    });
  }

  componentDidMount() {
    this.props.actions.fetch();
  }

  render() {
    const activeForm = this.state.abm.activeForm;
    return (
      <Grid container spacing={24}>
        <Grid item sm={12} md={12} lg={12}>
          <AsyncTable
            columnDefinition={this.state.table.columnData}
            title="Sucursales"
            data={this.props.data.data.data}
            defaultOrder={{
              name: "name",
              direction: "desc",
            }}
            headerButtons={
              <Tooltip title="Agregar">
                <IconButton aria-label="Agregar" onClick={this.showDialog}>
                  <AddIcon />
                </IconButton>
              </Tooltip>
            }
          />
        </Grid>
        <Dialog open={this.state.abm.open} maxWidth={"md"} fullWidth={true}>
          <Paper className={this.props.classes.abm}>
            <Grid container>
              {activeForm && (
                <Grid item lg={7}>
                  <EnhancedSchemaForm
                    formData={this.state.abm}
                    schema={this.state.schemaBranch}
                    onSubmit={this.handleSubmit}
                  >
                    {this.state.duplicateBranch && (
                      <div style={{ marginBottom: 15 }}>
                        <strong>
                          El nombre de la sucursal ya existe. Verifique sus
                          datos...{" "}
                        </strong>
                      </div>
                    )}
                    <div>
                      <Button variant="contained" onClick={this.hideDialog}>
                        Cancelar
                      </Button>
                      &nbsp;
                      <Button variant="contained" color="primary" type="submit">
                        Aceptar
                      </Button>
                    </div>
                  </EnhancedSchemaForm>
                </Grid>
              )}
              <Grid item lg={activeForm ? 5 : 12}>
                {activeForm ? (
                  <div
                    className={this.props.classes.textMap}
                    style={{ marginTop: 25, marginBottom: 5 }}
                  >
                    <Button
                      style={{ marginTop: 10 }}
                      variant="flat"
                      color="primary"
                      type="submit"
                      onClick={() =>
                        this.setState({
                          abm: { ...this.state.abm, activeForm: false },
                          center: { ...this.state.center },
                        })
                      }
                    >
                      Editar ubicación
                    </Button>
                  </div>
                ) : (
                  <>
                    <div
                      className={this.props.classes.textMap}
                      style={{ marginBottom: 85 }}
                    >
                      <h6>Elegir ubicación de la sucursal para continuar</h6>
                    </div>
                  </>
                )}
                <LocationMap
                  refStreet={this.refStreet}
                  zoom={13}
                  activeForm={activeForm}
                  center={this.state.center}
                  changeLocation={this.changeLocation}
                  changeStreet={this.changeStreet}
                  changeAddress={this.onAddressMounted}
                />

                {!activeForm && (
                  <div style={{ textAlign: "right" }}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      onClick={() =>
                        this.setState({
                          abm: { ...this.state.abm, activeForm: true },
                          center: { ...this.state.center },
                        })
                      }
                    >
                      Aceptar
                    </Button>
                  </div>
                )}
              </Grid>
            </Grid>
          </Paper>
        </Dialog>
      </Grid>
    );
  }
}

const mapStateToProps = (state: IStore, ownProps: BranchProps) => ({
  ...ownProps,
  data: state.branch,
  user: state.auth.user,
});

const styled = withStyles(styles as any)(Branchs);
const connected = connect(mapStateToProps, bindActions(BranchActions))(styled);

export default connected as ComponentClass<Partial<BranchProps>>;



// WEBPACK FOOTER //
// ./src/pages/branch.tsx